"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Indicator = exports.MeterialTabs = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
var INDICATOR_SIDE_PADDING_PX = 8;
var INDICATOR_HEIGHT_PX = 3;
exports.MeterialTabs = styled_components_1.default(core_1.Tabs).withConfig({ displayName: "MeterialTabs", componentId: "sc-19m5lpf" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["background-color:", ";.MuiTab-wrapper{width:unset;}.MuiTabs-indicator{height:", "px;background:transparent;}"], ["", "", ""])), function (_a) {
    var theme = _a.theme;
    return theme.vui.component.tab.background;
}, INDICATOR_HEIGHT_PX);
exports.Indicator = styled_components_1.default.span.withConfig({ displayName: "Indicator", componentId: "sc-1xx3m8j" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["display:block;position:relative;width:", "px;height:", "px;background-color:", ";margin:0 auto;transition:300ms cubic-bezier(0.4, 0, 0.2, 1)0ms;&::before{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:", ";border-radius:2px 2px 0px 0px;}"], ["", "", "", "", ""])), function (_a) {
    var width = _a.width;
    return width + INDICATOR_SIDE_PADDING_PX;
}, INDICATOR_HEIGHT_PX, function (_a) {
    var theme = _a.theme;
    return theme.vui.component.tab.background;
}, function (_a) {
    var theme = _a.theme;
    return theme.vui.component.tab.indicator.color;
});
var templateObject_1, templateObject_2;
